import { motion, AnimatePresence } from 'framer-motion';
import { Link } from "react-router-dom"
import { useAuth } from '../contexts/AuthContext'
import { useTheme } from '../contexts/ThemeContext'
import ThemeToggle from './ThemeToggle'

function Header() {
  const { user, logout } = useAuth();
  const { darkMode } = useTheme();

  const handleLogout = async () => {
    try {
      const confirmed = window.confirm('Are you sure you want to logout?');
      if (confirmed) {
        // Add loading animation while logging out
        await logout();
      }
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className="fixed top-0 left-0 right-0 z-50 bg-white/80 dark:bg-gray-800/80 backdrop-blur-lg shadow-sm"
    >
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <Link to="/" className="text-2xl font-bold bg-gradient-to-r from-primary-500 to-secondary-500 bg-clip-text text-transparent">
          InkWord
          </Link>
          
          <div className="flex items-center space-x-6">
            <ThemeToggle />
            
            {user ? (
              <div className="flex items-center space-x-4">
                {user.role === 'admin' && (
                  <motion.div
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    <Link
                      to="/create-post"
                      className="px-4 py-2 bg-gradient-to-r from-primary-500 to-secondary-500 text-white rounded-lg font-medium shadow-md hover:shadow-lg transition-all duration-200"
                    >
                      Create Post
                    </Link>
                  </motion.div>
                )}
                
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  className="relative group"
                >
                  <Link
                    to="/"
                    className="flex items-center space-x-2 text-gray-700 dark:text-gray-200 
                             hover:text-primary-500 dark:hover:text-primary-400 transition-colors duration-200"
                  >
                    <div className="w-10 h-10 rounded-full bg-gradient-to-r from-primary-500 to-secondary-500 
                                  flex items-center justify-center text-white font-medium overflow-hidden 
                                  ring-2 ring-white dark:ring-gray-800 group-hover:ring-primary-500 transition-all duration-200">
                      {user.avatar ? (
                        <img 
                          src={user.avatar}
                          alt={user.name}
                          className="w-full h-full object-cover"
                          onError={(e) => {
                            console.error('Image load error:', e);
                            e.target.onerror = null;
                            e.target.src = user.name?.charAt(0) || '?';
                          }}
                        />
                      ) : (
                        user.name?.charAt(0) || '?'
                      )}
                    </div>
                    <span className="font-medium group-hover:text-primary-500 dark:group-hover:text-primary-400">
                      {user.name}
                    </span>
                  </Link>
                  
                  <motion.div
                    initial={{ opacity: 0, y: 10, scale: 0.95 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={{ opacity: 0, y: 10, scale: 0.95 }}
                    className="absolute right-0 mt-2 w-48 bg-white dark:bg-gray-800 rounded-xl shadow-lg 
                             py-2 invisible group-hover:visible opacity-0 group-hover:opacity-100 
                             transform transition-all duration-200"
                  >
                    {/* <Link
                      to="/profile"
                      className="flex items-center px-4 py-2 text-gray-700 dark:text-gray-200 
                               hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-200"
                    >
                      <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" 
                              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                      </svg>
                      Profile Settings
                    </Link> */}
                    <button
                      onClick={handleLogout}
                      className="w-full flex items-center px-4 py-2 text-red-500 hover:bg-red-50 
                               dark:hover:bg-red-900/10 transition-colors duration-200"
                    >
                      <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" 
                              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                      </svg>
                      Logout
                    </button>
                  </motion.div>
                </motion.div>
              </div>
            ) : (
              <div className="flex items-center space-x-3">
                <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                  <Link to="/auth" className="px-4 py-2 text-gray-700 dark:text-gray-200 hover:text-primary-500">
                    Login
                  </Link>
                </motion.div>
                
                <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                  <Link to="/auth" className="px-4 py-2 bg-gradient-to-r from-primary-500 to-secondary-500 text-white rounded-xl">
                    Sign Up
                  </Link>
                </motion.div>
              </div>
            )}
          </div>
        </div>
      </div>
    </motion.header>
  )
}

export default Header

